module.exports = __webpack_public_path__ + "static/img/ability_banner.5e556aae.png";